import { send } from '../../../../../../src/network';
import { type CheckoutPricingInfo } from '../../../../../../src/types/CheckoutPricingInfo';

export function getCustomerCheckoutPricingInfoPath() {
  return `/api/v2/customers/self/checkout_pricing_info/`;
}

export async function getCustomerCheckoutPricingInfo() {
  return await send<CheckoutPricingInfo>({
    path: getCustomerCheckoutPricingInfoPath(),
    method: 'GET',
  });
}
